module.exports = __webpack_public_path__ + "static/media/Boreal-Besties9.f315cdee.jpg";